import types from '@/vuex/auth/actions-types'
import auth from '@/utils/auth'
import router from '@/router'

const actions = {
  [types.ALTERAR_CONFIGURACOES_USUARIO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando configuracoes' }, {root: true})
    try {
      await auth.alterarConfiguracoesUsuario(payload)
      commit(types.ALTERAR_CONFIGURACOES_USUARIO, payload)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Configurações alteradas com sucesso' }, {root: true})
      router.push({name: 'CaixaPostal'})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ocorreu um erro ao tentar alterar as configurações do usuário' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando configuracoes' }, {root: true})
    }
  },

  [types.SET_USUARIO]: async ({ commit }, payload) => {
    if (!payload.dadosAuth || !payload.dadosConfiguracoes || !payload.dadosPermissoes) {
      commit(types.SET_USUARIO, { usuario: undefined })
    } else {
      let usuario = {}
      usuario.id = payload.dadosAuth.data.idUsuario
      usuario.username = payload.dadosAuth.data.username
      usuario.nome = payload.dadosAuth.data.usuario.nome
      usuario.permissoes = payload.dadosPermissoes.data
      let { emailNotificacoes, emailPessoal, ...configuracoes } = payload.dadosConfiguracoes.data
      usuario.configuracoes = configuracoes
      usuario.email = emailNotificacoes
      usuario.emailPessoal = emailPessoal
      usuario.idPessoa = payload.dadosAuth.data.usuario.idPessoa
      commit(types.SET_USUARIO, { usuario: usuario })
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/auth/actions.js